import React from 'react';
import { Accordion } from '../ui/Accordion';
import { faqs } from '../../data/content';
export function FAQ() {
  return <section className="py-24 relative" data-id="element-48" data-mp="392g4zag1eay5">
      <div className="container mx-auto px-4" data-id="element-49" data-mp="38z1ypr495hlf">
        <div className="text-center mb-16" data-id="element-50" data-mp="2u576zxw8a8xg">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white flex items-center justify-center gap-3" style={{
          fontSize: "40px",
          color: "#22301A"
        }} data-id="element-51" data-mp="2u68l6b8jjbje">
             LO QUE MÁS NOS PREGUNTAN
          <span aria-hidden="true" data-id="element-52" data-mp="3mv5pfafx37t5">❓</span></h2>
        </div>

        <Accordion items={faqs} data-id="element-53" data-mp="3rql23z26uxnz" />
      </div>
    </section>;
}